import {Observable} from 'rxjs';
import i18next from 'i18next';

import {combineEpics} from 'web-app/util/redux-observable';
import * as GlobalEventActions from 'web-app/react/global-event/actions';

import * as Actions from './actions';
import * as Api from './api';
import {Type} from './constants';

const handleNapEvent = (childId, napType, value) => {
    const requestObservable = napType === Type.START_NAP ? Api.sleep(childId, value) : Api.wakeUp(childId, value);

    return requestObservable.catch(e => Observable.of(Actions.napFailure.action(e)));
};

const handleCheckOn = childId => {
    const requestObservable = Api.checkOnChild(childId);

    return requestObservable.catch(e => Observable.of(Actions.napFailure.action(e)));
};

const nap = action$ =>
    action$
        .ofType(Actions.nap.type)
        .mergeMap(({payload}) => {
            const {childIds, names, napType} = payload;
            const observables = childIds.map(childId => handleNapEvent(childId, napType, payload.value));
            return Observable.combineLatest(...observables).map(responses => ({responses, names, napType}));
        })
        .flatMap(({responses, names, napType}) => {
            const failureEvent = responses.find(r => r.type === Actions.napFailure.type);
            if (failureEvent) {
                // If any of the requests fail we emit a single failure event.
                return [failureEvent];
            } else {
                return [
                    GlobalEventActions.updateSuccess.action(
                        i18next.t(napType === Type.START_NAP ? 'group_tag.wasPutToSleep' : 'group_tag.wokenUp', {
                            count: responses.length,
                            name: names.get(0),
                        }),
                    ),
                    Actions.napSuccess.action({}),
                ];
            }
        });

const checkOn = action$ =>
    action$
        .ofType(Actions.checkOn.type)
        .mergeMap(({payload}) => {
            const {childIds, names} = payload;
            const observables = childIds.map(childId => handleCheckOn(childId));
            return Observable.combineLatest(...observables).map(responses => ({responses, names}));
        })
        .flatMap(({responses, names}) => {
            const failureEvent = responses.find(r => r.type === Actions.checkOnFailure.type);
            if (failureEvent) {
                // If any of the requests fail we emit a single failure event.
                return [failureEvent];
            } else {
                return [
                    GlobalEventActions.updateSuccess.action(
                        i18next.t('group_tag.wasCheckedOn', {
                            count: responses.length,
                            name: names.get(0),
                        }),
                    ),
                    Actions.checkOnSuccess.action({}),
                ];
            }
        });

export default combineEpics(checkOn, nap);
